import React, { ReactNode } from 'react';
import { TaktIdProvider, useTaktId } from '../../TaktIdContext';

export interface TaktWrapperProps {
  taktId: string;
  children: ReactNode;
}

const TaktWrapper = ({
  taktId,
  children,
}: TaktWrapperProps) => {
  const { dataTaktFeature } = useTaktId({});
  if (!dataTaktFeature) {
    return (
      <TaktIdProvider taktId={taktId}>
        {children}
      </TaktIdProvider>
    );
  }

  return (
    <>{children}</>
  );
}

export default TaktWrapper;
